/* eslint radix: ["error", "as-needed"] */
/* eslint-disable no-unexpected-multiline */
import React from 'react'
import Modal from 'react-modal';
import { prop, head, tail as tailFunction } from './functional'
// import firstBy from 'thenby'
/*
{
  "rules": {
    "dinosaurs": {
      ".indexOn": ["height", "length"]
    }
  }
}
*/

// const randomNumber = (n) => (Math.random()* n + 1) << 0
// const randomName = (list = ['Kian','Shahla','Claire','Josefina','Babak','Ali']) => list[randomNumber(list.length - 1)] 



const Message = ({ tail, defaultTail, longestTail, directionText }) => directionText ? (
  <div>
    <h3 className="currentScore">CURRENT SCORE: {tail - 5} </h3>
    <h2 className="localTopScore">LOCAL TOP SCORE: {
      longestTail - defaultTail > 0 ? longestTail - defaultTail : 0
    }</h2>
  </div>

) : (

    <div>
      <h3>PRESS ANY ARROW KEY TO START THE GAME</h3>
    </div>

  )

const Close = () => (
  <svg viewBox="0 0 40 40" width="45" height="50">
    <path style=
      {({
        stroke: 'black',
        fill: 'transparent',
        strokeLinecap: 'round',
        strokeWidth: 5
      })}
      d="M 10,10 L 30,30 M 30,10 L 10,30" />
  </svg>
)



const modalStyle = {
  position: 'absolute',
  top: '3px',
  right: '0px',
}


const firebaseSnapshotAsArray = snapshot => {
  let array = []
  snapshot.forEach(function (child) {
    array.push({
      id: child.key,
      ...child.val()
    })
  })
  return array
}

export const scoreboardActions = firebaseDb => firebaseScoreboard => store => ({
  openScoreModal(state) {
    // firebaseDb.goOnline()
    return ({ scoreModalIsOpen: true, firebaseOnlineRequested: true })
  },
  closeScoreModal(state) {
    // firebaseDb.goOffline()
    return ({ scoreModalIsOpen: false, firebaseOnlineRequested: false })
  },
  loadScoreboard(state) {
    const scoreboard = firebaseScoreboard
    scoreboard.on('value', snapshot => {
      const scores = firebaseSnapshotAsArray(snapshot)
        .slice()
        .sort((a, b) => b.score - a.score)
        .slice(0, 10)
      // emit scores once scoreboard is ready
      store.setState({ scoreboard: scores })

    })
  },
  resetLocalLongestTail(state) {
    localStorage.setItem('longestTail', 0)
    return ({ longestTail: 0 })
  }
})

const BestScores = ({ scoreboard, defaultTail }) => scoreboard ? (
  <ol>
    {
      scoreboard.filter(i => parseInt(i.score) - defaultTail > 0).map(({ name, score, id }) =>
        <li key={id}><div>{name.toUpperCase()}</div><span>{score - defaultTail} </span></li>)
    }
  </ol>
) : (<div>Loading...</div>)


export const ShowScore = ({ defaultTail, tail, longestTail, directionText, scoreboard, scoreModalIsOpen, openScoreModal, closeScoreModal, resetLocalLongestTail }) => (
  <div>
    <Message {...{ tail, longestTail, directionText, defaultTail }} />
    <button className="button topScores" onClick={openScoreModal}>
      VIEW ALL TIME TOP SCORES
    </button>
    {(tail <= defaultTail) ? <button className="button resetLocal" onClick={resetLocalLongestTail}>
      RESET LOCAL TOP SCORE
    </button> : ''}
    <Modal
      className="scoreModal"
      isOpen={scoreModalIsOpen}
      contentLabel="Example Modal"
      ariaHideApp={false}
    >
      <h2>BEST SCORES</h2>
      <div style={modalStyle} onClick={closeScoreModal}>
        <Close />
      </div>

      <BestScores {...{ scoreboard, defaultTail } } />

    </Modal>
  </div>
)


const handleName = setUsername => event => {
  setUsername(event.target.value.toLowerCase().trim().slice(0,15))
}


const recordLongestTail = firebaseDb => firebaseScoreboard => store => ({ tail, username, scoreboard, gameId, firebaseOnlineRequested }) => {

  // gaurds
  // username required to save
  if (!scoreboard || !username || !username.trim().length) {
    return
  }

  if (scoreboard.length >= 10 && Math.min(scoreboard.map(prop('score'))) <= tail) {
    // This score isn't a best score
    return
  }


  const currentGameRow = { name: username, score: tail, gameId }

  // Crud operations
  const addGame = game => firebaseDb
    .ref('scoreboard')
    .push(currentGameRow)

  const updateGame = id => row => firebaseDb
    .ref('scoreboard')
    .child(id)
    .update(row)

  const deleteGames = arr => arr.map(({ id }) => 
    firebaseDb
      .ref('scoreboard')
      .child(id)
      .remove()
  )
  

  // Game only shows one top score per player
  const reverseSort = arr => arr
    ? arr.slice().sort((a, b) => b.score - a.score)
    : []
  const matchingByNameArray = scoreboard.filter(i => i.name === username)
  const playersBestGames = reverseSort(matchingByNameArray
    .concat(currentGameRow))


  const scoreboardGamesMatchCurrentGameId = reverseSort(scoreboard.filter(i => i.gameId === gameId))
  const topGameMatchingCurrentId = head(scoreboardGamesMatchCurrentGameId)
  const otherGamesMatchingCurrentId = tailFunction(scoreboardGamesMatchCurrentGameId)

  const deleteExcessGamesByName = () => {
    // const playersTopGame = head(playersBestGames)
    const playersOtherGames = tailFunction(playersBestGames)
      .filter(prop('id'))
      .filter(row => row.gameId !== currentGameRow.gameId)

    return deleteGames(playersOtherGames.concat(otherGamesMatchingCurrentId))
  }


  // main flow

  // Do you even lift?
  if (currentGameRow.score <= Math.min(matchingByNameArray.map(prop('score')))) {
    return
  }


  let promises = []
  if (topGameMatchingCurrentId) {
    promises.push(updateGame(topGameMatchingCurrentId.id)(currentGameRow))
    promises.push(deleteExcessGamesByName())
  } else {
    promises.push(addGame(currentGameRow))
    promises.push(deleteExcessGamesByName())
  }
  Promise.all(promises).then(
    // firebaseDb.goOffline()
  )
}

export const setLongestTailSubscription =
  firebaseDb =>
    firebaseScoreboard =>
      store =>
        ({
      tail,
          longestTail,
          shadowLongestTail = 0,
          defaultTail,
          shadowGameId = '',
          username,
          scoreboard,
          gameId,
          firebaseOnlineRequested
  }) => {
          // gaurd
          if (tail <= defaultTail) {
            return
          }

          if (tail > longestTail) {
            store.setState({ longestTail: tail })
            localStorage.setItem('longestTail', tail)
          }

          if (shadowGameId !== gameId) {
            // shadowLongestTail = 0
            store.setState({ shadowGameId: gameId, shadowLongestTail: 0 })
          }
          if (tail > shadowLongestTail) {
            // console.log('im here!')
            store.setState({ shadowLongestTail: tail })
            recordLongestTail
              (firebaseDb)
              (firebaseScoreboard)
              (store)
              ({ tail, username, scoreboard, gameId, firebaseOnlineRequested })
          }
        }



export const saveScoreActions = store => ({
  setUsername(state, username) {
    localStorage.setItem('username', username)
    return ({ username })
  }
})

export const PlayerName = ({ longestTail, tail, scoreboard, username, setUsername }) => (
  <div className="saveScore">
    <input type="text" placeholder="ENTER YOUR NAME HERE TO SAVE BEST SCORE..." value={username || ''} onChange={handleName(setUsername)} />
  </div>
)


// WEBPACK FOOTER //
// ./src/Score.js